/*
 * Copyright (c) Nexign, JSC, 2019.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.1.0
 * @since 1.1.0
 */


export enum EExpensesAnalyzerChart {
    CATEGORY = 'category',
    DYNAMIC = 'dynamic',
}
